import { Injectable } from '@angular/core';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class FnDatepRangeConfig extends NgbDatepickerConfig {
    constructor() {
        super();
    }
}
